import * as t from "io-ts";
import { createStopDocumentTypes } from "dora-contracts";

const { stopDocumentT } = createStopDocumentTypes({ dateTime: t.string });

export type StopDocument = t.TypeOf<typeof stopDocumentT>;
export const documentsT = t.array(stopDocumentT);
